import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProductCard3.vue?vue&type=template&id=38d21268"
import script from "./MoleculeEditionBillingAcademyProductCard3.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProductCard3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports